
import React, {useState} from 'react';
import HomePage from './HomePage';
import LoginPage from './LoginPage';


const AppLaunch = props => {
	const [homePageState, setHomePageState] = useState (true);
    const [loginPageState, setLoginPageState] = useState (false);


    const homePageStateChange = props => {
        setHomePageState(props.homePageState);
    }

    const loginPageStateChange = props => {
      setLoginPageState(props.loginPageState);
    }

  

    let passPropertiesToChild = {
        homePageStateChange,loginPageStateChange,
        homePageState,loginPageState
    }

    return(
       
        <div>
            {homePageState && <HomePage{...passPropertiesToChild} />}
            {loginPageState && <LoginPage{...passPropertiesToChild} />}
        
            
        </div>
      
    );
}   

export default AppLaunch;



